import React, { Fragment } from 'react';
import Radium from 'radium';
import { UTLabel } from '@widergy/energy-ui';

import { appConfig } from 'config/customization';

import styles from './styles';

const EdenContentLayout = () =>
  appConfig.changeDueDate.content.map((content, index) => (
    <div key={content} style={styles.sectionContainer}>
      <div style={[styles.innerContainer, index > 0 && styles.minPadding]}>
        <div style={[styles.iconContainer, { backgroundColor: content.color }]}>
          <img alt={content.key} style={styles.icon} src={content.sideIcon} />
        </div>
        <div style={styles.textContainer}>
          <UTLabel bold small style={{ ...styles.title, color: content.color }}>
            {content.title}
          </UTLabel>
          <Fragment>
            {content.items.map(item => (
              <div key={item.id} style={styles.itemContentContainer}>
                <UTLabel light small>
                  {item.content}
                </UTLabel>
              </div>
            ))}
          </Fragment>
        </div>
      </div>
      {content.sideIcon && appConfig.socialRate.content.length - 1 > index && <hr style={styles.hr} />}
    </div>
  ));

export default Radium(EdenContentLayout);
